module.exports = __webpack_public_path__ + "img/slack1.63b9c5f7.png";